import { ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './Dialog.module.css';

export type DialogProps = {
  aberto: boolean;
  onFechar: () => void;
  titulo: string;
  descricao?: string;
  children?: ReactNode;
  acoes: ReactNode;
};

/** Confirmação pequena e centrada (destrutivas, avisos). Esc fecha; portal. */
export default function Dialog({ aberto, onFechar, titulo, descricao, children, acoes }: DialogProps) {
  useEffect(() => {
    if (!aberto) return;
    const aoTeclar = (evento: KeyboardEvent) => {
      if (evento.key === 'Escape') onFechar();
    };
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
  }, [aberto, onFechar]);

  useEffect(() => {
    if (!aberto) return;
    const anterior = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = anterior;
    };
  }, [aberto]);

  if (!aberto) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onFechar}>
      <div
        className={styles.cartao}
        role="alertdialog"
        aria-modal="true"
        onClick={(evento) => evento.stopPropagation()}
      >
        <div className={styles.titulo}>{titulo}</div>
        {descricao && <div className={styles.descricao}>{descricao}</div>}
        {children && <div className={styles.corpo}>{children}</div>}
        <div className={styles.acoes}>{acoes}</div>
      </div>
    </div>,
    document.body
  );
}
